export const LOGO_URL = "/eazikast-logo.png";
export const LOGO_MARK_URL = "/eazikast-mark.png";

export function Logo({ className = "h-9" }) {
  return (
    <img
      src={LOGO_URL}
      alt="EAZIKAST"
      data-testid="brand-logo"
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}
